import { Contractor } from "@/types/contractor";

export const getTopRatedContractors = (contractors: Contractor[]) => {
  return [...contractors]
    .filter(c => c.featured)
    .sort((a, b) => {
      // First priority: Edmond Window Cleaning
      if (a.name === 'Edmond Window Cleaning') return -1;
      if (b.name === 'Edmond Window Cleaning') return 1;
      
      // Second priority: H Industries
      if (a.name === 'H Industries') return -1;
      if (b.name === 'H Industries') return 1;
      
      // Then sort by rating * review_count for remaining contractors
      return (b.rating * b.review_count) - (a.rating * a.review_count);
    })
    .slice(0, 3);
};